/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowformatincluded3Inputs */

const en_aiflowformatincluded3 = /** @type {(inputs: Aiflowformatincluded3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 format included in the package`)
};

const de_aiflowformatincluded3 = /** @type {(inputs: Aiflowformatincluded3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Format im Paket inklusive`)
};

/**
* | output |
* | --- |
* | "1 format included in the package" |
*
* @param {Aiflowformatincluded3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowformatincluded3 = /** @type {((inputs?: Aiflowformatincluded3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowformatincluded3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowformatincluded3(inputs)
	return de_aiflowformatincluded3(inputs)
});
export { aiflowformatincluded3 as "aiFlowFormatIncluded" }